module.exports = __webpack_public_path__ + "img/13.64e39063.jpg";